export default "skymp5-front/da2bdc52391929ba70695178bb204b65.png";